module.exports = __webpack_public_path__ + "static/media/template-hd2.ad52f23f.png";